module.exports = __webpack_public_path__ + "img/message.3b815a21.png";